
import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import Footer from './components/Footer';
import ContactSection from './pages/ContactSection';
import AboutSection from './components/AboutSection';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import GallerySection from './pages/GallerySection';
import Booking from './pages/Booking';
import Ourfleets from './pages/Ourfleets';
import Mumbaioutstaioncabs from './pages/Mumbai Outstation Cabs';
import Mumbaitomahabaleshwarcab from './pages/Mumbai to Mahabaleshwar Cab';
import Mumbaitogoacabs from './pages/Mumbai to Goa Cabs';
import Mumbaitoshirdicab from './pages/Mumbai to Shirdi Cab';
import Mumbainashikcab from './pages/Mumbai Nashik Cab';
import Mumbaitokolhapurcab from './pages/Mumbai to Kolhapur Cab';
import Mumbaitopunecab from './pages/Mumbai to Pune Cab';
import Mumbaitoaurangabadcab from './pages/Mumbai to Aurangabad Cab';
import Mumbaitobhimashankarcab from './pages/Mumbai to Bhimashankar Cab';
import Mumbaitoashtavinayakcabservice from './pages/Mumbai to Ashtavinayak Cab Service';
import Mumbaitofivejyotilingacab from './pages/Mumbai to 5 Jyotirlinga Cab';
import Mumbaitolonavalacab from './pages/Mumbai to Lonavala Cab';
import Mumbaitokonkandarshancabbooking from './pages/Mumbai to Konkan Darshan Cab Booking';
import Mumbaitoalibaugcab from './pages/Mumbai to Alibaug Cab';
import Mumbaitoahmednagarcab from './pages/Mumbai to Ahmednagar Cab';
import Mumbaitomatherancab from './pages/Mumbai to Matheran Cab';
import Mumbaitojalgaoncabbookingdhule from './pages/Mumbai to Jalgaon Cab Booking Dhule';
import Mumbaitolavasacab from './pages/Mumbai to Lavasa Cab';
import Mumbaitopanchganicab from './pages/Mumbai to Panchgani Cab';
import Mumbaitokhandalataxifare from './pages/Mumbai to Khandala Taxi Fare';
import Mumbaitosuratcab from './pages/Mumbai to Surat Cab';
import Mumbaitoahmedabadcab from './pages/Mumbai to Ahmedabad Cab';
import Mumbaitonarmadaparikramacabbooking from './pages/Mumbai to Narmada Parikrama Cab Booking';
import Mumbaitovadodaracab from './pages/Mumbai to Vadodara Cab';
import Mumbaitodamantaxi from './pages/Mumbai to Daman Taxi';
import Mumbaitovapicab from './pages/Mumbai to Vapi Cab';
import Mumbaitobanglorecab from './pages/Mumbai to Bangalore Cab';
import Mumbaitoindorecab from './pages/Mumbai to Indore Cab';
import Mumbaitojaipurtaxi from './pages/Mumbai to Jaipur Taxi';
import Mumbaiairporttopunecab from './pages/Mumbai Airport to Pune Cabs';
import Mumbaitoimagicacab from './pages/Mumbai to Imagica Cab';
import Cabserviceinmumbai from './pages/Cab service in Mumbai';
import Besttaxiserviceinmumbai from './pages/Best Taxi Service in Mumbai';
import Onlinetaxibookingmumbai from './pages/Online taxi booking Mumbai';
import Mumbaidarshancabs from './pages/Mumbai darshan cabs';
import Weddingcarrentalmumbai from './pages/Wedding car rental Mumbai';
import Onewaycabservice from './pages/One way cab service';
import Corporatecabserviceinmumbai from './pages/Corporate cab services in Mumbai';
import Cabcompaniesinmumbai from './pages/Cab Companies in Mumbai';
import Mumbaicarrentalservice from './pages/Mumbai Car Rental Service';
import Roundtripcabbookingmumbai from './pages/Round Trip Cab Booking Mumbai';
import Cabserviceinthane from './pages/Cab Service in Thane';
import Cabservicenearmemumbai from './pages/Cab Service Near Me Mumbai';
import Swiftdzireonrentinmumbai from './pages/Swift Dzire on Rent in Mumbai';
import Cabserviceinnavimumbai from './pages/Cab Service in Navi Mumbai';
import Taxiserviceatmumbaiinternationalairport from './pages/Taxi Service at Mumbai International Airport';
import Cabserviceinkalyancabservice from './pages/Cab Service in Kalyan Cab Service in Dombivali';
import Innovacarrentalmumbai from './pages/Innova Car Rental Mumbai';
import Innovacrystaonrentinmumbai from './pages/Innova Crysta on Rent in Mumbai';
import Ertigaonrentinmumbai from './pages/Ertiga On Rent in Mumbai';
import Sedancabservicemumbai from './pages/Sedan Cab Service Mumbai';
import Tempotravelleronrentmumbai from './pages/Tempo Traveller On Rent Mumbai';
import Minibusonrentinmumbai from './pages/Mini Bus on Rent in Mumbai';
import Kiacarencecabserviceinmumbai from './pages/Kia Carens Cab Service in Mumbai';
import Toyotaetiononrentinmumbai from './pages/Toyota Etios on Rent in Mumbai';
import Carrentalmumbai from './pages/Car Rental Mumbai';
import Exploreindiapanindiacabbooking from './pages/Explore India  Pan India Cab Booking Services';
import Mumbaitopandharpurakkalkottuljapur from './pages/Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking';
import Outstationtaxiserviceinmumbai from './pages/Outstation Taxi Service in Mumbai';
import Carhireforoutstaioninmumbai from './pages/Car Hire for Outstation in Mumbai';
import Mumbaitohyderabadcab from './pages/Mumbai to Hyderabad Cabs';
import Mumbaicabservice from './pages/Mumbai Cab Service';
import Bestcabserviceinmumbai from './pages/Best Cab Service in Mumbai';
import Mumbaitoayodhyacab from './pages/Mumbai to Ayodhya Cab';
import Mumbaitosaputaracab from './pages/Mumbai to Saputara Cabs';
import Mumbaitobhopalcab from './pages/Mumbai to Bhopal Cab';
import Mumbaitotelanganacabservice from './pages/Mumbai to Telangana Cab Service';
import Mumbaitoshanishingnapurcab from './pages/Mumbai to Shani Shingnapur Cab';
import Mumbaitotrimkeshwarcab from './pages/Mumbai to Trimbakeshwar Cab';
import Mumbaiairporttovadodaracab from './pages/Mumbai Airport to Vadodara Cab';
import Mumbaitosolapurcab from './pages/Mumbai to Solapur Cab';
import Mumbaitoratnagiricab from './pages/Mumbai to Ratnagiri Cab';
import Mumbaitigrishneshwar from './pages/Mumbai to Grishneshwar Cab';
import Mumbaitopalgharcab from './pages/Mumbai to Palghar Cab';
import Mumbaitoujjaincab from './pages/Mumbai to Ujjain Cab';
import Mumbaitojaipurcab from './pages/Mumbai to Jaipur Cab';
import Mumbaitogujratcab from './pages/Mumbai to Gujarat Cab';
import Innovaonrentmumbai from './pages/Innova On Rent Mumbai';
import Kiacarenceonrentinmumbai from './pages/Kia Carens On Rent in Mumbai';
import Navimumbaiairportcab from './pages/Navi Mumbai Airport Cab';
import Navimumbaiairportcabservice from './pages/Navi Mumbai Airport Cab Service';
import Navimumbaiairporttopunecab from './pages/Navi Mumbai Airport to Pune Cab';
import Navimumbaiairporttonashikcab from './pages/Navi Mumbai Airport to Nashik Cab';
import Onlinecabbookingnavimumbaiairport from './pages/Online Cab Booking Navi Mumbai Airport';
import Navimumbaiairporttolonavalacab from './pages/Navi Mumbai Airport to Lonavala Cabs';
import Navimumbaitaxiservice from './pages/Navi Mumbai Taxi Service';
import Navimumbaitomahabaleshwarcab from './pages/Navi Mumbai to Mahabaleshwar Cab';
import Navimumbaitoshirditaxifare from './pages/Navi Mumbai to Shirdi Taxi Fare';
import Kharghartaxiservice from './pages/Kharghar Taxi Service';
import Navimumbaitokolhapurcab from './pages/Navi Mumbai to Kolhapur Cab';
import Innovacrystaonrentinnavimumbai from './pages/Innova Crysta On Rent in Navi Mumbai';
import Ertigaonrentinnavimumbai from './pages/Ertiga On Rent in Navi Mumbai';
import Swiftdzireonrentinnavimumbai from './pages/Swift Dzire on Rent in Navi Mumbai';
import Navimumbaiairporttogoacab from './pages/Navi Mumbai Airport to Goa Cabs';
import Navimumbaiinternationalairportcab from './pages/Navi Mumbai International Airport Cab';
import Navimumbaitoashtavinayakcab from './pages/Navi Mumbai to Ashtavinayak Cab Service';
import Navimumbaitofivejyotilingacab from './pages/Navi Mumbai to 5 Jyotirlinga Darshan Cab';
import Roundtripcabnavimumbai from './pages/Round Trip Cab Navi Mumbai';
import Outstationcabservicenavimumbai from './pages/Outstation Cab Service Navi Mumbai';
import Navimumbaitopunedailycab from './pages/Navi Mumbai to Pune Daily Cab Service';
import Navimumbaicorporatecabservicce from './pages/Navi Mumbai Corporate Cab Service';
import Navimumbaiinternationairport from './pages/Navi Mumbai International Airport (NMIA) Cabs';
import Packages from './pages/Packages';
import Enquiry from './pages/Enquiry';
import ContactButtons from './components/ContactButtons';
import ScrollToTop from './components/ScrollToTop';
import Omservice from './pages/omservice';
function App() {
  return (
    <Router>
<Header/>
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<Omservice />} />
        <Route path="/gallery" element={<GallerySection />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/our-fleet" element={<Ourfleets />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/contact-us" element={<ContactSection />} />
        <Route path="/Mumbai-Outstation-Cab" element={<Mumbaioutstaioncabs />} />
      
      <Route path="/Mumbai-to-Mahabaleshwar-Cab" element={<Mumbaitomahabaleshwarcab />} />
<Route path="/Mumbai-to-Goa-Cabs" element={<Mumbaitogoacabs />} />
<Route path="/Mumbai-to-Shirdi-Cab" element={<Mumbaitoshirdicab />} />
<Route path="/Mumbai-Nashik-Cab" element={<Mumbainashikcab />} />
<Route path="/Mumbai-to-Kolhapur-Cab" element={<Mumbaitokolhapurcab />} />
<Route path="/Mumbai-to-Pune-Cab" element={<Mumbaitopunecab />} />
<Route path="/Mumbai-to-Aurangabad-Cab" element={<Mumbaitoaurangabadcab />} />
<Route path="/Mumbai-to-Bhimashankar-Cab" element={<Mumbaitobhimashankarcab />} />
<Route path="/Mumbai-to-Ashtavinayak-Cab-Service" element={<Mumbaitoashtavinayakcabservice />} />
<Route path="/Mumbai-to-5-Jyotirlinga-Cab" element={<Mumbaitofivejyotilingacab />} />
<Route path="/Mumbai-to-Lonavala-Cab" element={<Mumbaitolonavalacab />} />
<Route path="/Mumbai-to-Konkan-Darshan-Cab-Booking" element={<Mumbaitokonkandarshancabbooking />} />
<Route path="/Mumbai-to-Alibaug-Cab" element={<Mumbaitoalibaugcab />} />
<Route path="/Mumbai-to-Ahmednagar-Cab" element={<Mumbaitoahmednagarcab />} />
<Route path="/Mumbai-to-Matheran-Cab" element={<Mumbaitomatherancab />} />
<Route path="/Mumbai-to-Jalgaon-Cab-Booking-Dhule" element={<Mumbaitojalgaoncabbookingdhule />} />
<Route path="/Mumbai-to-Lavasa-Cab" element={<Mumbaitolavasacab />} />
<Route path="/Mumbai-to-Panchgani-Cab" element={<Mumbaitopanchganicab />} />
<Route path="/Mumbai-to-Khandala-Taxi-Fare" element={<Mumbaitokhandalataxifare />} />
<Route path="/Mumbai-to-Surat-Cab" element={<Mumbaitosuratcab />} />
<Route path="/Mumbai-to-Ahmedabad-Cab" element={<Mumbaitoahmedabadcab />} />
<Route path="/Mumbai-to-Narmada-Parikrama-Cab-Booking" element={<Mumbaitonarmadaparikramacabbooking />} />
<Route path="/Mumbai-to-Vadodara-Cab" element={<Mumbaitovadodaracab />} />
<Route path="/Mumbai-to-Daman-Taxi" element={<Mumbaitodamantaxi />} />
<Route path="/Mumbai-to-Vapi-Cab" element={<Mumbaitovapicab />} />
<Route path="/Mumbai-to-Bangalore-Cab" element={<Mumbaitobanglorecab />} />
<Route path="/Mumbai-to-Indore-Cab" element={<Mumbaitoindorecab />} />
<Route path="/Mumbai-to-Jaipur-Taxi" element={<Mumbaitojaipurtaxi />} />
<Route path="/Mumbai-Airport-to-Pune-Cabs" element={<Mumbaiairporttopunecab />} />
<Route path="/Mumbai-to-Imagica-Cab" element={<Mumbaitoimagicacab />} />







<Route path="/Cab-service-in-Mumbai" element={<Cabserviceinmumbai />} />
<Route path="/Best-taxi-service-in-Mumbai" element={<Besttaxiserviceinmumbai />} />
<Route path="/Online-taxi-booking-Mumbai" element={<Onlinetaxibookingmumbai />} />
<Route path="/Mumbai-darshan-cabs" element={<Mumbaidarshancabs />} />
<Route path="/Wedding-car-rental-Mumbai" element={<Weddingcarrentalmumbai />} />
<Route path="/One-way-cab-service" element={<Onewaycabservice />} />
<Route path="/Corporate-cab-services-in-Mumbai" element={<Corporatecabserviceinmumbai />} />
<Route path="/Cab-Companies-in-Mumbai" element={<Cabcompaniesinmumbai />} />
<Route path="/Mumbai-Car-Rental-Service" element={<Mumbaicarrentalservice />} />
<Route path="/Round-Trip-Cab-Booking-Mumbai" element={<Roundtripcabbookingmumbai />} />
<Route path="/Cab-Service-in-Thane" element={<Cabserviceinthane />} />
<Route path="/Cab-Service-Near-Me-Mumbai" element={<Cabservicenearmemumbai />} />
<Route path="/Swift-Dzire-on-Rent-in-Mumbai" element={<Swiftdzireonrentinmumbai />} />
<Route path="/Cab-Service-in-Navi-Mumbai" element={<Cabserviceinnavimumbai />} />
<Route path="/Taxi-Service-at-Mumbai-International-Airport" element={<Taxiserviceatmumbaiinternationalairport />} />
<Route path="/Cab-Service-in-Kalyan-Cab-Service-in-Dombivali" element={<Cabserviceinkalyancabservice />} />



<Route path="/Innova-Car-Rental-Mumbai" element={<Innovacarrentalmumbai />} />
<Route path="/Innova-Crysta-on-Rent-in-Mumbai" element={<Innovacrystaonrentinmumbai />} />
<Route path="/Ertiga-On-Rent-in-Mumbai" element={<Ertigaonrentinmumbai />} />
<Route path="/Sedan-Cab-Service-Mumbai" element={<Sedancabservicemumbai />} />
<Route path="/Tempo-Traveller-On-Rent-Mumbai" element={<Tempotravelleronrentmumbai />} />
<Route path="/Mini-Bus-on-Rent-in-Mumbai" element={<Minibusonrentinmumbai />} />
<Route path="/Kia-Carens-Cab-Service-in-Mumbai" element={<Kiacarencecabserviceinmumbai />} />
<Route path="/Toyota-Etios-on-Rent-in-Mumbai" element={<Toyotaetiononrentinmumbai />} />
<Route path="/Car-Rental-Mumbai" element={<Carrentalmumbai />} />
<Route path="/Explore-India-Pan-India-Cab-Booking-Services" element={<Exploreindiapanindiacabbooking />} />
<Route path="/Mumbai-to-Pandharpur-Akkalkot-Tuljapur-Cab-Booking" element={<Mumbaitopandharpurakkalkottuljapur />} />
<Route path="/Outstation-Taxi-Service-in-Mumbai" element={<Outstationtaxiserviceinmumbai />} />
<Route path="/Car-Hire-for-Outstation-in-Mumbai" element={<Carhireforoutstaioninmumbai />} />
<Route path="/Mumbai-to-Hyderabad-Cabs" element={<Mumbaitohyderabadcab />} />
<Route path="/Mumbai-Cab-Service" element={<Mumbaicabservice />} />
<Route path="/Best-Cab-Service-in-Mumbai" element={<Bestcabserviceinmumbai />} />
<Route path="/Mumbai-to-Ayodhya-Cab" element={<Mumbaitoayodhyacab />} />
<Route path="/Mumbai-to-Saputara-Cabs" element={<Mumbaitosaputaracab />} />
<Route path="/Mumbai-to-Bhopal-Cab" element={<Mumbaitobhopalcab />} />
<Route path="/Mumbai-to-Telangana-Cab-Service" element={<Mumbaitotelanganacabservice />} />
<Route path="/Mumbai-to-Shani-Shingnapur-Cab" element={<Mumbaitoshanishingnapurcab />} />
<Route path="/Mumbai-to-Trimbakeshwar-Cab" element={<Mumbaitotrimkeshwarcab />} />
<Route path="/Mumbai-Airport-to-Vadodara-Cab" element={<Mumbaiairporttovadodaracab />} />
<Route path="/Mumbai-to-Solapur-Cab" element={<Mumbaitosolapurcab />} />
<Route path="/Mumbai-to-Ratnagiri-Cab" element={<Mumbaitoratnagiricab />} />
<Route path="/Mumbai-to-Grishneshwar-Cab" element={<Mumbaitigrishneshwar />} />
<Route path="/Mumbai-to-Palghar-Cab" element={<Mumbaitopalgharcab />} />
<Route path="/Mumbai-to-Ujjain-Cab" element={<Mumbaitoujjaincab />} />
<Route path="/Mumbai-to-Jaipur-Cab" element={<Mumbaitojaipurcab />} />
<Route path="/Mumbai-to-Gujarat-Cab" element={<Mumbaitogujratcab />} />
<Route path="/Innova-On-Rent-Mumbai" element={<Innovaonrentmumbai />} />
<Route path="/Kia-Carens-On-Rent-Mumbai" element={<Kiacarenceonrentinmumbai />} />
<Route path="/Navi-Mumbai-Airport-Cab" element={<Navimumbaiairportcab />} />
<Route path="/Navi-Mumbai-Airport-Cab-Service" element={<Navimumbaiairportcabservice />} />
<Route path="/Navi-Mumbai-Airport-to-Pune-Cab" element={<Navimumbaiairporttopunecab />} />
<Route path="/Navi-Mumbai-Airport-to-Nashik-Cab" element={<Navimumbaiairporttonashikcab />} />
<Route path="/Online-Cab-Booking-Navi-Mumbai-Airport" element={<Onlinecabbookingnavimumbaiairport />} />
<Route path="/Navi-Mumbai-Airport-to-Lonavala-Cabs" element={<Navimumbaiairporttolonavalacab />} />
<Route path="/Navi-Mumbai-Taxi-Service" element={<Navimumbaitaxiservice />} />
<Route path="/Navi-Mumbai-to-Mahabaleshwar-Cab" element={<Navimumbaitomahabaleshwarcab />} />
<Route path="/Navi-Mumbai-to-Shirdi-Taxi-Fare" element={<Navimumbaitoshirditaxifare />} />
<Route path="/Kharghar-Taxi-Service" element={<Kharghartaxiservice />} />
<Route path="/Navi-Mumbai-to-Kolhapur-Cab" element={<Navimumbaitokolhapurcab />} />
<Route path="/Innova-Crysta-On-Rent-in-Navi-Mumbai" element={<Innovacrystaonrentinnavimumbai />} />
<Route path="/Ertiga-On-Rent-in-Navi-Mumbai" element={<Ertigaonrentinnavimumbai />} />
<Route path="/Swift-Dzire-on-Rent-in-Navi-Mumbai" element={<Swiftdzireonrentinnavimumbai />} />
<Route path="/Navi-Mumbai-Airport-to-Goa-Cabs" element={<Navimumbaiairporttogoacab />} />
<Route path="/Navi-Mumbai-International-Airport-Cab" element={<Navimumbaiinternationalairportcab />} />
<Route path="/Navi-Mumbai-to-Ashtavinayak-Cab-Service" element={<Navimumbaitoashtavinayakcab />} />
<Route path="/Navi-Mumbai-to-5-Jyotirlinga-Darshan-Cab" element={<Navimumbaitofivejyotilingacab />} />
<Route path="/Round-Trip-Cab-Navi-Mumbai" element={<Roundtripcabnavimumbai />} />
<Route path="/Outstation-Cab-Service-Navi-Mumbai" element={<Outstationcabservicenavimumbai />} />
<Route path="/Navi-Mumbai-to-Pune-Daily-Cab-Service" element={<Navimumbaitopunedailycab />} />
<Route path="/Navi-Mumbai-Corporate-Cab-Service" element={<Navimumbaicorporatecabservicce />} />
<Route path="/Navi-Mumbai-International-Airport-NMIA-Cabs" element={<Navimumbaiinternationairport />} />
      </Routes>



      <Footer />
    </Router>
  );
}

export default App;
